export default {
  refreshYourResults: 'Oppdater resultatene dine',
  weNeedTo: 'For å få se de siste prisene og tilgjengelighet må vi',
  refreshResults: 'oppdatere resultatene dine.',
  okRefresh: 'OK, oppdater',
}
